module.exports = __webpack_public_path__ + "static/media/card-ads-full-es.d8e4d5d2.png";